import { TransactionStatus } from '../../../hooks/useTransactionMonitor';
import { OrderPostingStatus } from '../OpenOrdersStore';
import { PositionPostingStatus } from '@/feature/terminal_tables/position/PositionStore';

export const ApiStatusToTransactionStatus: Record<OrderPostingStatus | PositionPostingStatus, TransactionStatus> = {
  idle: 'idle',
  preparing: 'preparing',
  confirming: 'confirming',
  confirmed: 'confirmed',
  failed: 'failed',
};
